import React, { useState, useEffect, useCallback, useRef } from "react";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { customStyles } from "../styles/table-style";
import "../../assets/css/style.css";
import BASE_URL from "../../assets/global/url";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TypedDateInput, {
  DATE_INPUT_FORMAT,
} from "../../components/inputs/TypedDateInput";
import swal from "sweetalert";
import { ThreeDot } from "react-loading-indicators";
import NoAccess from "../../assets/img/NoAccess.png";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
import { Modal, Button, Form } from "react-bootstrap";
import { format } from "date-fns";
import { PaginationControls } from "../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../hooks/customHook/paginationHook/useServerPagination";
import { useServerSort } from "../../hooks/customHook/sortingHook/useTableSort";
import Select from "react-select";
import { selectCustomStyles } from "../../assets/global/selectCustomStyles";
import useDarkMode from "../../components/Themes/Usedarkmode";
import {
  compactNumberFormat,
  formatToPHP,
  formatToTwoDecimal,
} from "../../utils/numberFormatter";
import DateRangePicker from "../../components/DateRangePicker";
import { Tab, Tabs } from "react-bootstrap";
import { getMonthBoundaries, initializeCutoff } from "../../utils/newdate";
import FilterStore from "../../hooks/customHook/FilterStore";

function BankTransaction({ authrztn }) {
  const { themeSelectStyles } = useDarkMode();
  const userLoggedID = useDecodeToken();

  const [inboundData, setInboundData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [accounts, setAccounts] = useState([]);
  // const [selectedAccount, setSelectedAccount] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const pageRestored = useRef(false);
  // const [searchText, setSearchText] = useState("");
  const [filterColumn, setFilterColumn] = useState("all");

  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const [currencyRate, setCurrencyRate] = useState("");
  const [bankTransactionRowData, setBankTransactionRowData] = useState([]);
  const [paymentData, setPaymentData] = useState({});

  const [showDateModal, setShowDateModal] = useState(false);
  const [selectedPayDate, setSelectedPayDate] = useState("");
  const [pendingConfirmRow, setPendingConfirmRow] = useState(null);
  // --------------------------------------------------
  // const [activeTab, setActiveTab] = useState("pending");

  const [totals, setTotals] = useState({
    totalBalance: 0,
    totalWithdraw: 0,
    totalDeposit: 0,
  });
  const [selectedCutOff, setSelectedCutOff] = useState(""); // state for input select
  const [cutOffs, setCutOffs] = useState([]); // state for all cut off
  const [cutOffDate, setCutOffDate] = useState(""); // state for input date

  // Filters Retention when switching pages
  const [searchText, setSearchText] = useState(() => FilterStore.BTgetSearch());
  useEffect(() => {
    FilterStore.BTsaveSearch(searchText);
  }, [searchText]);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = FilterStore.getTab();
    return ["pending", "confirmed"].includes(savedTab) ? savedTab : "pending";
  });

  const [selectedAccount, setSelectedAccount] = useState(() => {
    const saved = FilterStore.getSelected();
    return Array.isArray(saved) && saved.length === 0 ? "" : saved;
  });

  const pagination = useServerPagination(
    BASE_URL + "/bankTransaction/getBankTransaction",
    FilterStore.BTgetPerPage(),
  );

  // No initial sortBy: the backend default (newest first) has no visible column,
  // so every header starts neutral until the user picks one
  const sort = useServerSort(pagination);

  ///PARA ITO SA FILTER RETENTION NG PAGE
  //START
  // Save gate — stays closed until after mount restore settles,
  // so the hook's internal reset-to-1 from updateParams doesn't overwrite the saved page.
  useEffect(() => {
    if (!pageRestored.current) return;
    if (pagination.currentPage) {
      FilterStore.BTsavePage(pagination.currentPage);
    }
  }, [pagination.currentPage]);

  useEffect(() => {
    if (pagination.itemsPerPage) {
      FilterStore.BTsavePerPage(pagination.itemsPerPage);
    }
  }, [pagination.itemsPerPage]);

  // Restore last viewed page on mount. setTimeout(0) defers until after
  // fetchCutOff → reloadTable → updateParams → hook's reset-to-1 has settled,
  // then opens the save gate for user navigation.
  useEffect(() => {
    const savedPage = FilterStore.BTgetPage();
    if (savedPage > 1) {
      setTimeout(() => {
        pagination.setCurrentPage(savedPage);
        pageRestored.current = true;
      }, 0);
    } else {
      setTimeout(() => {
        pageRestored.current = true;
      }, 0);
    }
  }, []);
  //END

  const handleCutoffChange = (value) => {
    let filteredCutoff;
    if (value === "All Cutoff" || !value) {
      const ascendingSortedCutoff = cutOffs.sort(
        (a, b) => new Date(b.from) - new Date(a.from),
      );
      filteredCutoff = {
        from: ascendingSortedCutoff[ascendingSortedCutoff.length - 1]?.from,
        to: ascendingSortedCutoff[0]?.to,
      };
    } else {
      [filteredCutoff] = cutOffs.filter((item) => {
        return item.id == value;
      });
    }
    return filteredCutoff;
  };

  // handle change select cutoff date
  const handleSelect = (e) => {
    const filteredCutoff = handleCutoffChange(e.target.value);
    // setSearchText("");
    pagination.setCurrentPage(1);

    setSelectedCutOff(filteredCutoff);
    // setSelectedAccount("");
    reloadTable(filteredCutoff, null);
  };

  const fetchCutOff = () => {
    // axios
    // .get(BASE_URL + "/cutoff/getCutoffs")
    // .then((res) => {
    //   let defaultCutOff = res.data[0];
    //   // get the latest date for default cut off
    //   for (let index = 1; index < res.data.length; index++) {
    //     if (res.data[index].to > defaultCutOff.to) {
    //       defaultCutOff = res.data[index];
    //     }
    //   }
    //   if (selectedCutOff) {
    //     const filteredCutoff = handleCutoffChange(selectedCutOff?.id);

    // const boundaries = getMonthBoundaries();
    // const initialCutoff = initializeCutoff(boundaries);

    const savedDates = FilterStore.get();
    let initialCutoff;

    if (savedDates) {
      initialCutoff = savedDates;
    } else {
      const boundaries = getMonthBoundaries();
      initialCutoff = initializeCutoff(boundaries);
    }

    // } else {
    //   setCutOffs(res.data); // store all cut off
    setSelectedCutOff(initialCutoff);
    setCutOffDate(initialCutoff);
    setTimeout(() => {
      // reloadTable(initialCutoff, selectedAccount?.value || null);
      const currentAccount =
        Array.isArray(FilterStore.getSelected()) &&
        FilterStore.getSelected().length === 0
          ? null
          : FilterStore.getSelected()?.value;
      reloadTable(initialCutoff, currentAccount);
      fetchAccountListSub3();
    }, 100);
    //   }
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
  };

  useEffect(() => {
    fetchCutOff();
  }, []);
  // set start and end date for input date
  const startAndEndDate = useCallback(() => {
    const filteredCutoff = handleCutoffChange(selectedCutOff?.id);

    setCutOffDate(filteredCutoff); // set state for input date
  }, [cutOffs, selectedCutOff]);

  useEffect(() => {
    startAndEndDate();
  }, [selectedCutOff]);

  const reloadTable = (cutOff, accountsName) => {
    pagination.updateParams({
      startDate: cutOff?.from,
      endDate: cutOff?.to,
      accountsName,
      filterColumn,
      searchText,
      statusTab: activeTab,
    });
    setIsLoading(false);
    // axios
    //   .get(BASE_URL + "/bankTransaction/getBankTransaction", {
    //     params: {
    //       startDate: cutOff?.from,
    //       endDate: cutOff?.to,
    //       accountsName,
    //       filterColumn,
    //       searchText,
    //     },
    //   })
    //   .then((res) => {
    //     setInboundData(res.data.bankTransaction);
    //     setFilteredData(res.data.bankTransaction);
    //     console.log(res.data.bankTransaction);
    //     // calculateTotals(res.data);

    //     setTotals({
    //       totalBalance: (0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    //       totalWithdraw:
    //         res.data.totalIn
    //           ?.toFixed(2)
    //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0,
    //       totalDeposit:
    //         res.data.totalOutCombinedAmount
    //           ?.toFixed(2)
    //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0,
    //     });
    //     console.log(res.data);
    //     setIsLoading(false);
    //   })
    //   .catch((err) => console.log(err));
  };

  const fetchAccountListSub3 = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/issuedCheck/getAccountListSub3`,
      );
      const accountNames = response.data.map((item) => {
        return { id: item.id, account_name: item.account_name };
      });
      const uniqueAccountsSet = [...new Set(accountNames)];
      setAccounts(uniqueAccountsSet);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     filterData();
  //   }, 1500);

  //   return () => clearTimeout(timer);
  // }, [selectedAccount, startDate, endDate]);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     filterData();
  //   }, 1500);

  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    setInboundData(pagination.data.bankTransaction);
    setFilteredData(pagination.data.bankTransaction);
    // calculateTotals(pagination);
    setTotals({
      totalBalance: (0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      totalDeposit:
        pagination.data.totalIn
          ?.toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0,
      totalWithdraw:
        pagination.data.totalOutCombinedAmount
          ?.toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0,
    });
  }, [pagination.data]);

  // ====== Commented ======
  // useEffect(() => {
  //   fetchCutOff();
  // }, [searchText]);

  // useEffect(() => {
  //   setSearchText("");
  //   fetchCutOff();
  // }, [filterColumn]);

  // useEffect(() => {
  //   if (selectedAccount && filterColumn == "account_name") {
  //     setFilterColumn("all");
  //   }
  // }, [selectedAccount]);
  // ========================================================================================================

  // ======= New data range, search filter and selector: useEffect =======
  useEffect(() => {
    const timer = setTimeout(() => {
      if (selectedCutOff || cutOffDate) {
        const currentCutoff = selectedCutOff || cutOffDate;

        pagination.updateParams({
          startDate: currentCutoff?.from,
          endDate: currentCutoff?.to,
          accountsName: selectedAccount?.value || null,
          filterColumn: filterColumn,
          searchText: searchText,
          statusTab: activeTab,
        });
        setIsLoading(false);
      }
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedCutOff,
    cutOffDate,
    selectedAccount,
    filterColumn,
    searchText,
    activeTab,
  ]);
  // ========================================================================================================

  const filterData = () => {
    let filtered = inboundData;
    console.log(inboundData);
    if (selectedAccount) {
      filtered = filtered.filter(
        (data) => data.account_list?.account_name === selectedAccount,
      );
    }

    if (startDate) {
      filtered = filtered.filter(
        (data) =>
          new Date(data.transaction_date).setHours(0, 0, 0, 0) >=
          startDate.setHours(0, 0, 0, 0),
      );
    }

    if (endDate) {
      filtered = filtered.filter(
        (data) =>
          new Date(data.transaction_date).setHours(23, 59, 59, 999) <=
          endDate.setHours(23, 59, 59, 999),
      );
    }

    setFilteredData(filtered);
    calculateTotals(filtered);
    setIsLoading(false);
  };

  const calculateTotals = (data) => {
    const totalBalance = data.reduce(
      (sum, item) => sum + parseFloat(item.balanace || 0),
      0,
    );
    const totalWithdraw = data.reduce(
      (sum, item) => sum + parseFloat(item.withdraw || 0),
      0,
    );
    const totalDeposit = data.reduce(
      (sum, item) => sum + parseFloat(item.deposit || 0),
      0,
    );

    setTotals({
      totalBalance: totalBalance
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      totalWithdraw: totalWithdraw
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      totalDeposit: totalDeposit
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    });
  };

  // List of currency symbol
  const currencySymbol = {
    PHP: "₱",
    JPY: "¥",
    USD: "$",
    EUR: "€",
    HKD: "HK$",
    CNY: "CN¥",
  };

  const columns = [
    {
      name: "Account",
      selector: (row) =>
        row.account_list_id_bank_froms?.account_name ||
        row.account_list_id_bank_tos?.account_name ||
        "---",
      sortField: "account_name",
    },
    {
      name: "Date Process",
      selector: (row) =>
        row.processDate ? format(row.processDate, "MMM/dd/yyyy") : "---",
      sortField: "process_date",
    },
    {
      name: "Maturity Date",
      selector: (row) =>
        row.transaction_date
          ? format(row.transaction_date, "MMM/dd/yyyy")
          : "---",
      sortField: "transaction_date",
    },
    {
      name: "Transaction Number",
      selector: (row) => row.transaction_number || "---",
      sortField: "transaction_number",
    },
    {
      name: "Issued To",
      selector: (row) => row.account_list_id_bank_tos?.account_name || "---",
      sortField: "issued_to",
    },
    {
      name: "Subject From",
      selector: (row) => row.module_from || "---",
      sortField: "module_from",
    },
    {
      name: "Description",
      selector: (row) => row.description || "---",
      sortField: "description",
    },
    {
      name: "Amount",
      selector: (row) => formatToTwoDecimal(row.amount),
      sortField: "amount",
      cell: (row) => (
        <div
          className={`${
            row.account_list_id_bank_froms?.account_name &&
            row.module_from == "Collection Check"
              ? "text-primary"
              : row.transaction_number.includes("TRANSFER-") &&
                  row.account_list_id_bank_tos == null
                ? "text-primary"
                : row.account_list_id_bank_froms?.account_name
                  ? "text-danger"
                  : "text-primary"
          }`}>
          {row.account_list_id_bank_froms?.account_name &&
          row.module_from == "Collection Check"
            ? "+"
            : row.transaction_number.includes("TRANSFER-") &&
                row.account_list_id_bank_tos == null
              ? "+"
              : row.account_list_id_bank_froms?.account_name
                ? "-"
                : "+"}{" "}
          {
            currencySymbol[
              row.account_list_id_bank_froms?.currency?.currency_name ||
                row.account_list_id_bank_tos?.currency?.currency_name
            ]
          }
          {formatToTwoDecimal(row.amount)}
        </div>
      ),
    },
    // {
    //   name: "Exchange Rate Used",
    //   cell: (row) => (
    //     <div>
    //       {currencySymbol["PHP"]}
    //       {row.exchangeRate?.toLocaleString("en-US", {
    //         minimumFractionDigits: String(row.exchangeRate).length > 4 ? 3 : 2,
    //         maximumFractionDigits: String(row.exchangeRate).length > 4 ? 3 : 2,
    //       })}{" "}
    //     </div>
    //   ),
    // },
    // {
    //   name: "Converted Amount",
    //   cell: (row) => (
    //     <div>
    //       {currencySymbol["PHP"]}
    //       {row.convertedAmount?.toLocaleString("en-US", {
    //         minimumFractionDigits: 2,
    //         maximumFractionDigits: 2,
    //       })}
    //     </div>
    //   ),
    // },
    {
      name: "Status",
      selector: (row) => row.status,
      sortField: "status",
      cell: (row) => (
        <div
          style={{
            padding: "5px 10px",
            borderRadius: "5px",
            color: row.status
              ? row.status === "Pending"
                ? "#FFA500"
                : "#3B9F3F"
              : "initial",
            textTransform: "uppercase",
            fontWeight: "bold",
          }}>
          {row.status}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => {
        const isPayableOrExpense = [
          "Local Payable",
          "Overseas Payable",
          "Local Expenses",
          "Overseas Expenses",
        ].includes(row.module_from);

        // Maturity date hasn't arrived yet.
        const isBeforeMaturity = row.transaction_date
          ? format(new Date(), "yyyy-MM-dd") <
            format(row.transaction_date, "yyyy-MM-dd")
          : false;

        // cutoffValid comes from getBankTransaction: true only when an
        // active (isDeleted: false), not-yet-posted Cutoff covers this
        // row's maturity date. Missing/undefined is treated as blocked.
        const isCutoffBlocked = !row.cutoffValid;

        const isConfirmDisabled =
          row.status !== "Pending" || isBeforeMaturity || isCutoffBlocked;

        const confirmTitle =
          row.status !== "Pending"
            ? ""
            : isBeforeMaturity
              ? "Cannot confirm before the maturity date"
              : isCutoffBlocked
                ? "No active cutoff period covers this maturity date"
                : "";

        return (
          <div className="d-flex gap-3 align-items-center">
            <button
              onClick={() => handleConfirmButtonClick(row)}
              className={`btn btn-primary ${
                isConfirmDisabled ? "disabled" : ""
              }`}
              disabled={isConfirmDisabled}
              title={confirmTitle}
              style={{
                cursor: isConfirmDisabled ? "not-allowed" : "pointer",
              }}>
              Confirm
            </button>
            <div className={`${isPayableOrExpense ? "" : "pe-none"}`}>
              <i
                className="fas fa-trash"
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: "1.5rem",
                  opacity: `${isPayableOrExpense ? 1 : 0.5}`,
                }}
                onClick={() =>
                  handleDeleteBankTransaction(row.id, row.processDate)
                }></i>
            </div>
          </div>
        );
      },
    },
  ];

  const handleConfirmButtonClick = (row) => {
    const rowData = inboundData.find((data) => data.id === row.id);
    setPendingConfirmRow({ row, rowData });
    // Default the pay date to today; the user can still change it
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    setSelectedPayDate(today);
    setShowDateModal(true);
  };

  const handleDateConfirm = () => {
    if (!selectedPayDate) {
      swal({
        title: "Date Required",
        text: "Please pick a pay date before proceeding.",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      return;
    }
    setShowDateModal(false);
    const { row, rowData } = pendingConfirmRow;
    handleConfirm(
      row.id,
      row.account_list_id_bank_from,
      row.amount,
      row.transaction_date,
      row.transaction_number,
      row.module_from,
      row.description,
      row.account_list_id_bank_froms.currency,
      rowData,
      selectedPayDate,
    );
  };

  const handleDeleteBankTransaction = async (
    bankTransactionId,
    processDate,
  ) => {
    try {
      const deleteBankTransaction = await swal({
        icon: "warning",
        title: "Confirm Deletion",
        text: "Are you sure you want to delete?",
        buttons: ["Cancel", "Yes"],
        dangerMode: true,
      });

      if (!deleteBankTransaction) return; // Guard clause
      const res = await axios.delete(
        `${BASE_URL}/bankTransaction/delete-bank-transaction/${bankTransactionId}/${processDate}/${userLoggedID}`,
      );

      if (res.status === 200) {
        await swal({
          icon: "success",
          title: "Successfully Deleted",
          text: "Issued check successfully deleted.",
        });

        fetchCutOff();
      }
    } catch (error) {
      console.error(error);

      if (error.response && error.response.status === 400) {
        swal({
          icon: "error",
          title: error.response.data.title,
          text: error.response.data.message,
        });
        return;
      } else if (error.response.status === 401) {
        swal({
          icon: "error",
          // title: "Please contact your support",
          title: error.response.data.title,
          text: error.response.data.message,
        }); // test 1
      } else {
        swal({
          icon: "error",
          title: "Something went wrong.",
          text: "Please contact our support team for assistance.",
        });
      }
    }
  };

  const handleConfirm = async (
    id,
    account_list_id_bank_from,
    amount,
    date,
    transaction_number,
    module_from,
    description,
    currency,
    rowData,
    selectedPayDate,
  ) => {
    console.log(rowData);
    const amountToUse =
      rowData.amount_to_deduct != null ? rowData.amount_to_deduct : amount;

    console.log(
      "amoun to use",
      amountToUse,
      rowData.amount_to_deduct,
      rowData.account_list_id_bank_to,
    );

    // const res = await axios.get(
    //   `${BASE_URL}/bankTransaction/validateBankTransaction/${account_list_id_bank_from}`
    // );

    // Check if this is a liability account or payable transaction
    const isLiabilityAccount =
      module_from === "Liabilities Account" ||
      module_from?.toLowerCase().includes("payable") ||
      description?.toLowerCase().includes("payable") ||
      description?.toLowerCase().includes("liability");

    // Only show insufficient balance modal for non-liability accounts
    // if (!isLiabilityAccount && amountToUse > res.data.amount) {
    //   swal({
    //     title: "Oppss!",
    //     text: "Insufficient Balance",
    //     icon: "error",
    //     button: false,
    //     timer: 2000,
    //   });
    //   return;
    // }

    // Only check balance for non-liability accounts
    if (!isLiabilityAccount) {
      try {
        const res = await axios.get(
          `${BASE_URL}/bankTransaction/validateBankTransaction/${account_list_id_bank_from}`,
        );
        const currentBalance = parseFloat(res.data?.amount || 0);

        if (currentBalance - parseFloat(amountToUse) < 0) {
          swal({
            title: "Oppss!",
            text: "Insufficient Balance",
            icon: "error",
            buttons: false,
            timer: 2000,
          });
          return;
        }
      } catch (error) {
        console.error(error);
      }
    }

    // if (currency.currency_name !== "PHP" || currency.id !== 1) {
    //   setBankTransactionRowData(rowData);
    //   setPaymentData({
    //     id,
    //     account_list_id_bank_from,
    //     amount,
    //     date,
    //     transaction_number,
    //     module_from,
    //     description,
    //     userLoggedID,
    //   });
    //   handleShowModal();
    //   return;
    // }

    try {
      const toPay = await swal({
        title: "Are you sure?",
        text: "Once confirmed, you will not be able to recover this transaction",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      if (toPay) {
        await axios
          .post(BASE_URL + "/bankTransaction/v2/confirmBankTransaction", {
            id,
            account_list_id_bank_from,
            amount,
            date,
            transaction_number,
            module_from,
            description,
            userLoggedID,
            amountToDeduct:
              rowData.amount_to_deduct != null ? rowData.amount_to_deduct : 0,
            account_list_id_bank_to: rowData.account_list_id_bank_to,
            currencyName: rowData?.currencyName ?? "PHP",
            currencyRate: rowData?.exchangeRate ?? 1,
            rowData,
            selectedPayDate,
            processDate: selectedPayDate,
          })
          .then((res) => {
            if (res.status === 200) {
              swal({
                title: "Bank Transaction Confirmed",
                text: "The bank transaction has been confirmed",
                icon: "success",
                timer: 2000,
              }).then(() => {
                // const [filteredCutoff] = cutOffs.filter((item) => {
                //   return item.id === selectedCutOff?.id;
                // });
                const currentCutoff = selectedCutOff || cutOffDate;
                reloadTable(currentCutoff, selectedAccount?.value);
              });
            } else if (res.status === 202) {
              swal({
                title: "Oppss!",
                text: `Insufficient Balance`,
                icon: "error",
                buttons: false,
                timer: 2000,
              });
              return;
            } else {
              swal({
                title: "Something went wrong",
                text: "Please contact your support immediately",
                icon: "error",
                timer: 2000,
              });
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 409) {
              swal({
                title: "Oopps!",
                text: "Action is prohibited as the Issued date has already been posted",
                icon: "error",
                button: true,
              });
            } else if (error.response.status === 401) {
              swal({
                icon: "error",
                // title: "Please contact your support",
                title: error.response.data.title,
                text: error.response.data.message,
              }); // test 1
            }
          });
      }
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  // console.log(bankTransactionRowData);

  const handleSubmit = async () => {
    try {
      if (currencyRate == "") {
        swal({
          title: "Field required.",
          text: "Please fill in the Foreign rate.",
          icon: "error",
          timer: 2000,
        });
        return;
      }

      const toPay = await swal({
        title: "Are you sure?",
        text: "Once confirmed, you will not be able to recover this transaction",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (toPay) {
        const {
          id,
          account_list_id_bank_from,
          amount,
          date,
          transaction_number,
          module_from,
          description,
          userLoggedID,
        } = paymentData;

        await axios
          .post(BASE_URL + "/bankTransaction/confirmBankTransaction", {
            id,
            account_list_id_bank_from,
            amount,
            date,
            transaction_number,
            module_from,
            description,
            userLoggedID,
            bankTransactionRowData,
            currencyRate,
          })
          .then((res) => {
            if (res.status === 200) {
              swal({
                title: "Bank Transaction Confirmed",
                text: "The bank transaction has been confirmed",
                icon: "success",
                timer: 2000,
              }).then(() => {
                // const [filteredCutoff] = cutOffs.filter((item) => {
                //   return item.id === selectedCutOff?.id;
                // });
                const currentCutoff = selectedCutOff || cutOffDate;
                reloadTable(currentCutoff, selectedAccount?.value);
                handleCloseModal();
              });
            } else if (res.status === 202) {
              swal({
                title: "Oopps!",
                text: "Action is prohibited as the date has already been posted",
                icon: "error",
                button: true,
              });
              return;
            } else {
              swal({
                title: "Something went wrong",
                text: "Please contact your support immediately",
                icon: "error",
                timer: 2000,
              });
            }
          });
      }
    } catch (error) {
      console.error(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  const userData = filteredData?.map((data, i) => {
    const transactionDate = new Date(data.transaction_date);
    const formattedDate = transactionDate.toLocaleDateString("en-PH", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    return {
      key: i,
      id: data.id,
      account_list_id_bank_from: data.account_list_id_bank_from,
      account_list_id_bank_to: data.account_list_id_bank_to,
      account_list_id_bank_froms: data.account_list_id_bank_froms,
      account_list_id_bank_tos: data.account_list_id_bank_tos,
      transaction_date: data.transaction_date,
      transaction_number: data.transaction_number,
      module_from: data.module_from,
      description: data.description,
      amount: data.amount,
      status: data.status,
      exchangeRate: data.exchangeRate,
      convertedAmount: data.convertedAmount,
    };
  });

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        [
          "Transaction #",
          "Account",
          "Transaction Date",
          "Description",
          "Issued To",
          "Subject From",
          "Amount",
          "Status",
        ],
      ],
      body: filteredData.map((data) => [
        data.transaction_number,
        data.account_list_id_bank_froms?.account_name,
        new Date(data.transaction_date).toLocaleDateString("en-PH", {
          year: "numeric",
          month: "short",
          day: "numeric",
        }),
        data.description,
        data.withdraw,
        data.module_from,
        data.amount,
        data.status,
      ]),
    });
    doc.save("bank_transactions.pdf");
  };

  // Account Options for dropdown select
  const accountOptions = accounts.map((item) => ({
    value: item.id,
    label: item.account_name,
  }));

  const totalIn = parseFloat(String(totals.totalDeposit).replace(/,/g, ""));

  const totalOut = parseFloat(String(totals.totalWithdraw).replace(/,/g, ""));

  const handleDateRangeChange = (startDate, endDate) => {
    const cutoff = {
      id: "custom",
      from: startDate,
      to: endDate,
    };
    setSelectedCutOff(cutoff);
    setCutOffDate(cutoff);
    // setSearchText("");
    // pagination.setCurrentPage(1);
    // setSelectedAccount("");
    // reloadTable(cutoff, selectedAccount?.value);
    FilterStore.save(startDate, endDate);
  };

  const tabFilteredData = filteredData?.filter((data) => {
    if (activeTab === "pending") {
      return data.status === "Pending";
    } else if (activeTab === "confirmed") {
      return data.status !== "Pending";
    }
    return true;
  });

  // Enhancement: Add a Clear all Filters
  const handleClearFilters = () => {
    const boundaries = getMonthBoundaries();
    const initialCutoff = initializeCutoff(boundaries);

    FilterStore.clear();
    FilterStore.BTsaveSearch("");
    FilterStore.saveTab("pending");

    setSelectedAccount(null);
    setSelectedCutOff(initialCutoff);
    setCutOffDate(initialCutoff);
    setSearchText("");
    setFilterColumn("all");
    setActiveTab("pending");
    pagination.setCurrentPage(1);
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      {isLoading ? (
        <div className="loading-container">
          <ThreeDot
            variant="brick-stack"
            color="#6290FE"
            size="large"
            text="Loading Data..."
            textColor=""
          />
        </div>
      ) : authrztn.includes("BankTransactions-View") ? (
        <>
          <div className="w-100 p-2 d-flex flex-row justify-content-between">
            <div className="d-flex flex-column title-custom">
              <span className="fs-3">BANK TRANSACTION - DETAILS</span>
            </div>
          </div>

          <div className="row mt-3">
            {/* <div className="col-md-4">
              <div className="card text-center">
                <div className="card-body">
                  <h5 className="card-title">Total Remaining Balance</h5>
                  <p className="card-text text-success amount">
                    ₱{totals.totalBalance}
                  </p>
                </div>
              </div>
            </div> */}
            <div className="col-md-6">
              <div className="card text-center">
                <div className="card-body">
                  <h5 className="card-title d-flex align-items-center justify-content-center">
                    <i class="bx bx-money me-1 h-100"></i>
                    Total of Deposit
                  </h5>
                  <p
                    className="card-text amount"
                    title={formatToTwoDecimal(totalIn)}
                    style={{
                      cursor: "default",
                      color: "var(--widget-number-color)",
                    }}>
                    {formatToPHP(totalIn)}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card text-center">
                <div className="card-body">
                  <h5 className="card-title d-flex align-items-center justify-content-center">
                    <i class="bx bxs-credit-card me-1 h-100"></i>
                    Total of Withdrawal
                  </h5>
                  <p
                    className="card-text amount"
                    title={formatToTwoDecimal(totalOut)}
                    style={{
                      cursor: "default",
                      color: "var(--widget-number-color)",
                    }}>
                    {formatToPHP(totalOut)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-100 row mx-0 mt-3 align-items-end">
            <div className="col-sm mb-2">
              {/* <select
                  className="form-select"
                  value={selectedAccount}
                  onChange={(e) => setSelectedAccount(e.target.value)}
                >
                  <option value="">Account</option>
                  {accounts.map((account, index) => (
                    <option key={index} value={account}>
                      {account}
                    </option>
                  ))}
                </select> */}
              <label htmlFor="">Account</label>
              {/* <select
                className="form-select"
                value={selectedAccount}
                onChange={(e) => {
                  setSelectedAccount(e.target.value);
                  const [filteredCutoff] = cutOffs.filter((item) => {
                    return item.id === selectedCutOff?.id;
                  });
                  reloadTable(filteredCutoff, e.target.value);
                }}
                onMouseDown={(e) => {
                  if (accounts.length === 0) {
                    e.preventDefault();
                    swal({
                      icon: "warning",
                      title: "No Account Found",
                      text: "No account found. Please add an account first",
                    });
                    return;
                  }
                }}
              >
                <option value="">All Account</option>
                {accounts.map((account, index) => (
                  <option key={index} value={account?.id}>
                    {account?.account_name}
                  </option>
                ))}
              </select> */}
              <Select
                options={accountOptions}
                value={selectedAccount}
                onChange={(selectedOption) => {
                  setSelectedAccount(selectedOption);
                  // const filteredCutoff = handleCutoffChange(selectedCutOff?.id);
                  // const currentCutoff = selectedCutOff || cutOffDate;
                  // reloadTable(currentCutoff, selectedOption?.value);
                  FilterStore.saveSelected(selectedOption || "");
                }}
                onMenuOpen={() => {
                  if (accounts.length === 0) {
                    swal({
                      icon: "warning",
                      title: "No Account Found",
                      text: "No account found. Please add an account first",
                    });
                    return;
                  }
                }}
                menuIsOpen={accounts.length === 0 ? false : undefined}
                placeholder={`All Account`}
                styles={themeSelectStyles(selectCustomStyles(selectedAccount))}
                isSearchable
                isClearable
              />
            </div>
            <div className="col-sm mb-2">
              <DateRangePicker
                startDate={
                  selectedCutOff?.from ? new Date(selectedCutOff.from) : null
                }
                endDate={
                  selectedCutOff?.to ? new Date(selectedCutOff.to) : null
                }
                onDateRangeChange={handleDateRangeChange}
                label="Date Range"
              />
              {/* <label htmlFor="">Cutoff</label>
              <select
                value={selectedCutOff?.id}
                onChange={handleSelect}
                className="form-select"
                onMouseDown={(e) => {
                  if (cutOffs.length === 0) {
                    e.preventDefault();
                    swal({
                      icon: "warning",
                      title: "No Cutoff Found",
                      text: "No cutoff records found. Please create a cutoff first in Monthly Cutoff Module.",
                    });
                    return;
                  }
                }}
              >
                <option value="All Cutoff">All</option>
                {cutOffs.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select> */}
            </div>
            {/* <div className="col-sm mb-2">
              <div className="input-group">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  placeholderText="From"
                  className="form-control"
                />
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  placeholderText="To"
                  className="form-control"
                  disabled={!startDate}
                />
              </div>
            </div> */}
            {/* <div className="col-sm mb-2">
              <label htmlFor="">From</label>
              <input
                type="date"
                name="cutoff-start-date"
                id="cutoff-start-date"
                className="form-control"
                value={cutOffDate?.from}
                readOnly
                // onChange={(e) => setDateFrom(e.target.value)}
              />
              <DatePicker
                selected={cutOffDate?.from}
                dateFormat="MMM/dd/yyyy"
                className="form-control"
                readOnly
              />
            </div>
            <div className="col-sm mb-2">
              <label htmlFor="">To</label>
              <input
                type="date"
                className="form-control"
                name="cutoff-end-date"
                id="cutoff-end-date"
                value={cutOffDate?.to}
                readOnly
                // onChange={(e) => setDateTo(e.target.value)}
              />
              <DatePicker
                selected={cutOffDate?.to}
                dateFormat="MMM/dd/yyyy"
                className="form-control"
                readOnly
              />
            </div> */}
            <div className="col-sm d-flex flex-row align-items-end mb-2 filter-btn-container w-100">
              {/* <button className="btn w-100">Apply Filter</button>
              <button
                className="btn btn-secondary w-100"
                onClick={() => {
                  setSelectedAccount("");
                  setStartDate(null);
                  setEndDate(null);
                }}
              >
                Clear Filter
              </button> */}
              <button
                className="btn btn-primary w-100"
                onClick={handleClearFilters}>
                <i className="bx bx-reset me-1"></i> Clear All Filters
              </button>
            </div>
          </div>

          {/* <div className="w-100 row mx-0 mt-3 align-items-center">
            {authrztn.includes("BankTransactions-IE") && (
              <div className="col-sm d-flex input-group justify-content-end mb-2 align-items-center">
                <CSVLink
                  data={userData}
                  filename={"bank_transactions.csv"}
                  className="btn btn-primary me-2 custom-btn"
                >
                  Export CSV
                </CSVLink>
                <button
                  onClick={exportPDF}
                  className="btn btn-primary custom-btn"
                >
                  Export PDF
                </button>
              </div>
            )}
          </div> */}
          <div className="w-100 mt-2 container-fluid">
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  FilterStore.BTsaveSearch(e.target.value);
                }}
              />
              <button
                type="button"
                className="btn btn-outline-secondary dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <i className="fa-solid fa-sliders"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "all" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("all")}>
                    All
                  </button>
                </li>
                {/* <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "account" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("account")}
                  >
                    Account
                  </button>
                </li> */}
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "account_name" ? "active" : ""
                    }`}
                    onClick={() => {
                      setFilterColumn("account_name");
                      setSelectedAccount("");
                    }}>
                    Account Name
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "date" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("date")}>
                    Date
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "transaction_number" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("transaction_number")}>
                    Transaction Number
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "issued_to" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("issued_to")}>
                    Issued To
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "subject_from" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("subject_from")}>
                    Subject From
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "description" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("description")}>
                    Description
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "amount" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("amount")}>
                    Amount
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "status" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("status")}>
                    Status
                  </button>
                </li>
              </ul>
            </div>
            {/* <div style={{ maxWidth: "78.5vw" }}>
              <div className="data-table-cell-width">
                <DataTable
                  columns={columns}
                  data={userData}
                  customStyles={customStyles}
                  className="dataTable"
                />
                <PaginationControls {...pagination} />
              </div>
            </div> */}

            <Tabs
              transition={false}
              mountOnEnter
              unmountOnExit={false}
              activeKey={activeTab}
              onSelect={(tab) => {
                setActiveTab(tab);
                FilterStore.saveTab(tab);
              }}
              id="bank-status-tabs"
              className="mb-3">
              <Tab
                eventKey="pending"
                title={`Pending (${pagination.data?.pendingCount || 0})`}>
                <div style={{ maxWidth: "78.5vw" }}>
                  <div className="data-table-cell-width">
                    <DataTable
                      columns={sort.sortColumns(columns)}
                      data={tabFilteredData}
                      customStyles={customStyles}
                      className="dataTable"
                      {...sort.sortProps}
                    />
                    <PaginationControls {...pagination} />
                  </div>
                </div>
              </Tab>
              <Tab
                eventKey="confirmed"
                title={`Confirmed (${pagination.data?.confirmedCount || 0})`}>
                <div style={{ maxWidth: "78.5vw" }}>
                  <div className="data-table-cell-width">
                    <DataTable
                      columns={sort.sortColumns(columns)}
                      data={tabFilteredData}
                      customStyles={customStyles}
                      className="dataTable"
                      {...sort.sortProps}
                    />
                    <PaginationControls {...pagination} />
                  </div>
                </div>
              </Tab>
            </Tabs>

            {/* Currency Rate Modal */}
            <Modal show={show} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Currency Rate</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <label htmlFor="currency-rate" className="mb-2">
                    Foreign Rate
                  </label>
                  <input
                    type="number"
                    id="currency-rate"
                    name="currency_rate"
                    className="form-control"
                    placeholder="Enter Foreign Rate"
                    value={currencyRate}
                    onChange={(e) => setCurrencyRate(e.target.value)}
                    onKeyDown={(e) => {
                      ["-", "e", "+"].includes(e.key) && e.preventDefault();
                    }}
                    min={0}
                    required
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}>
                  Submit
                </button>
              </Modal.Footer>
            </Modal>

            {/* Pay Date Modal — shown before Confirm proceeds */}
            <Modal
              show={showDateModal}
              onHide={() => setShowDateModal(false)}
              centered>
              <Modal.Header closeButton>
                <Modal.Title>Select Pay Date</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className="mb-2 text-muted" style={{ fontSize: "0.875rem" }}>
                  Please pick a pay date before proceeding with the
                  confirmation.
                </p>
                <Form.Label>Pay Date</Form.Label>
                {/* Replaced by the typed DatePicker below (same as create_invoice.jsx)
                <DatePicker
                  selected={selectedPayDate}
                  onChange={(date) => setSelectedPayDate(date)}
                  className="form-control"
                  placeholderText="Select a date"
                  dateFormat="MM/dd/yyyy"
                  isClearable
                  autoFocus
                /> */}
                <DatePicker
                  selected={selectedPayDate || null}
                  onChange={(date) => setSelectedPayDate(date)}
                  customInput={<TypedDateInput />}
                  className="form-control"
                  wrapperClassName="w-100"
                  placeholderText="MM/dd/yyyy"
                  dateFormat={DATE_INPUT_FORMAT}
                  strictParsing
                  autoComplete="off"
                  isClearable
                  autoFocus
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowDateModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleDateConfirm}>
                  Confirm &amp; Proceed
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}
    </div>
  );
}

export default BankTransaction;
